<div>
  <!-- Quotation Details Table -->
  <table class="table table-bordered mb-4">
    <thead class="thead-light">
      <tr>
        <th scope="col">Sr No</th>
        <th scope="col">Item Name</th>
        <th scope="col">Quantity</th>
        <th scope="col">Unit</th>
        <th scope="col">Cost</th>
        <th scope="col">Total Price</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of quotationItems; let i = index">
        <td>{{ i + 1 }}</td>
        <td>
          <div>{{ item.description || '-' }}</div>

          <div
            *ngIf="item.comments"
            class="fw-bold text-decoration-underline small mt-1"
          >
            (Note: {{ item.comments }})
          </div>
      </td>
        <td>{{ item.quantity }}</td>
        <td>{{ masterCommonServices.getUnitName(item.unit)?.unitName || '-' }}</td>
        <td>{{ item.unitPrice| number: '1.2-2' }}</td> <!-- Format to 2 decimal places -->
        <td>{{ item.totalPrice | number: '1.2-2' }}</td> <!-- Format to 2 decimal places -->
      </tr>
    </tbody>
  </table>

  <div class="row">
    <!-- Left Section with Heading and Table -->
    <div class="col-md-3">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th colspan="2" class="text-center">
              Terms and Conditions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="quotationTerms.currencyName">
            <th>Currency</th>
            <td>{{ quotationTerms.currencyName }}</td>
          </tr>
          <tr *ngIf="quotationTerms.packingType">
            <th>Packing Type</th>
            <td>{{ quotationTerms.packingType }}</td>
          </tr>
          <tr *ngIf="quotationTerms.deliveryTime">
            <th>Delivery Time</th>
            <td>{{ quotationTerms.deliveryTime }}</td>
          </tr>
          <tr *ngIf="quotationTerms.deliveryName">
            <th>Delivered To</th>
            <td>{{ quotationTerms.deliveryName }}</td>
          </tr>
          <tr *ngIf="quotationTerms.paymentName">
            <th>Payment Type</th>
            <td>{{ quotationTerms.paymentName }}</td>
          </tr>
          <tr *ngIf="quotationTerms.mtcTypeName">
            <th>MTC Type</th>
            <td>{{ quotationTerms.mtcTypeName }}</td>
          </tr>
          <tr *ngIf="quotationTerms.validityName">
            <th>Validity</th>
            <td>{{ quotationTerms.validityName }}</td>
          </tr>
          <tr *ngIf="quotationTerms.countryName">
            <th>Country of Origin</th>
            <td>{{ quotationTerms.countryName }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Right Section with Heading and Table -->
    <div class="col-md-3 ms-auto">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th colspan="2" class="text-center">
              Summary
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Net Total</th>
            <td>{{ quotationFields.netTotal | number: '1.2-2' }}</td> <!-- Format to 2 decimal places -->
          </tr>
          <tr>
            <th>GST Amount</th>
            <td>{{ quotationFields.gstAmount | number: '1.2-2' }}</td> <!-- Format to 2 decimal places -->
          </tr>
          <tr>
            <th>Grand Total</th>
            <td>{{ quotationFields.grandTotal | number: '1.2-2' }}</td> <!-- Format to 2 decimal places -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
